import { CallPut } from 'utils/shared/trades/types';

export const normalizeCallPut = (cp?: string | null): CallPut | null => {
  const normalized = cp?.trim().toLowerCase();

  if (normalized === 'c' || normalized === 'call') {
    return CallPut.Call;
  }

  if (normalized === 'p' || normalized === 'put') {
    return CallPut.Put;
  }

  return null;
};
